import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ApplicationHeader from "../application/ApplicationHeader";
import { Container } from "@material-ui/core";
import ApplicationPanel from "../application/ApplicationPanel";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import RipEndpointBrowse from "./RipEndpointBrowse";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },

  creatorLogo: {
    width: "100%",
    height: "100%",
  },
}));

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});

const ManageRipEndpoints = () => {
  const classes = useStyles();

  return (
    <Container id="manage-rip-endpoints" classes={{ root: classes.panel }}>
      <ApplicationHeader />

      <ApplicationPanel>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />

          <RipEndpointBrowse />
        </QueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageRipEndpoints;
